// Open/closed state of the full-height menu panel, shared by the desktop side
// rail and the mobile dock (they live in different parts of the tree).
import { useSyncExternalStore } from "react";

let open = false;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const menu = {
  open: () => ((open = true), emit()),
  close: () => ((open = false), emit()),
  toggle: () => ((open = !open), emit()),
};

export const useMenuOpen = () =>
  useSyncExternalStore(
    (l) => (listeners.add(l), () => listeners.delete(l)),
    () => open,
    () => false,
  );

export interface NavLinkDef {
  label: string;
  to: string;
  note?: string;
  external?: boolean;
}

export const PRIMARY: NavLinkDef[] = [
  { label: "Home", to: "/home" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Media Studio", to: "/media" },
  { label: "Voice Agent", to: "/voiceagent" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

export const SOLUTIONS: NavLinkDef[] = [
  { label: "HIBANE HR Desk", to: "/hrdesk", note: "Hire, onboard & manage your team" },
  { label: "HIBANE Books", to: "/financedesk", note: "Invoicing, expenses & cash flow" },
  { label: "HIBANE Voice Agent", to: "/voiceagent", note: "AI receptionist that never sleeps" },
  { label: "Business Suite", to: "/suite", note: "HR + Books in one workspace" },
];
